<template>
    <div class="home">
        <Summary />
    </div>
</template>
<script>
    // @ is an alias to /src
    import Summary from '@/components/Summary.vue'

    export default {
        name: 'summary-page',
        components: {
            Summary
        },
        created() {
            this.$parent.pageTitle = "Summary";
        }
    }
</script>
